export default __webpack_public_path__ + "static/media/hht2_ep18_book_wp_02.9d3c19c9.jpg";